import { useEffect } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router";
import { captureError } from "@utils/analytics.ts";
import { isChunkLoadError } from "@utils/chunkReload.ts";
import { ChunkErrorFallback } from "../ChunkErrorFallback/ChunkErrorFallback.tsx";

export const AppRouterError = () => {
  const error = useRouteError();

  useEffect(() => {
    console.error(error);

    // Chunk failures are expected after deploys; ChunkErrorFallback handles UX, not product analytics.
    if (!isChunkLoadError(error)) {
      captureError("Router error handler", error);
    }
  }, [error]);

  if (isChunkLoadError(error)) {
    return <ChunkErrorFallback error={error} />;
  }

  if (isRouteErrorResponse(error)) {
    return (
      <div className="h-full p-4">
        <h1 className="mb-4 text-xl">Server error</h1>
        <div>Status: {error.status}</div>
        <div>Description: {error.statusText}</div>
        {error.data && (
          <div>
            Data: <pre>{JSON.stringify(error.data, null, 4)}</pre>
          </div>
        )}
      </div>
    );
  }

  if (error instanceof Error) {
    return (
      <div className="h-full p-4">
        <div>
          <h1 className="mb-4 text-xl">App router error</h1>
          {error.stack?.indexOf(error.message) === -1 && <pre>{error.message}</pre>}
          <pre className="rounded border-2 border-red-200 bg-grey-900 p-4">
            {error.stack}
          </pre>
        </div>
      </div>
    );
  }
  return "Unknown error...";
};
